var _circle, _path, _path2, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9684 22.9883H23.6434C23.8644 23.0007 24.0848 22.9563 24.2838 22.8593C24.4827 22.7623 24.6535 22.6159 24.7799 22.4342C24.9062 22.2524 24.9839 22.0414 25.0055 21.8211C25.0271 21.6008 24.992 21.3786 24.9034 21.1758C24.6034 20.2691 23.4075 19.1816 23.4075 18.1116C23.4075 15.7366 23.4075 15.1116 22.2375 13.715C21.8589 13.2654 21.3895 12.9011 20.86 12.6458L20.2075 12.3291C20.098 12.2631 20.0036 12.1748 19.9303 12.07C19.8569 11.9653 19.8063 11.8463 19.7817 11.7208C19.7165 11.2978 19.4928 10.9155 19.1561 10.6513C18.8193 10.3871 18.3947 10.2609 17.9684 10.2983C17.5497 10.2732 17.1367 10.405 16.81 10.668C16.4834 10.9311 16.2665 11.3064 16.2017 11.7208C16.1723 11.8506 16.1148 11.9724 16.0331 12.0775C15.9515 12.1827 15.8477 12.2686 15.7292 12.3291L15.0767 12.6458C14.5476 12.9012 14.0784 13.2655 13.7 13.715C12.5309 15.1116 12.5309 15.7366 12.5309 18.1116C12.5309 19.1816 11.3892 20.16 11.0892 21.1208C10.9084 21.7016 10.8084 22.9883 12.3225 22.9883H17.9684Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6875 22.9883C20.6946 23.3473 20.6292 23.7041 20.4951 24.0372C20.3609 24.3704 20.1609 24.673 19.907 24.9269C19.653 25.1809 19.3504 25.3809 19.0173 25.515C18.6842 25.6491 18.3274 25.7146 17.9683 25.7074C17.6092 25.7151 17.2522 25.6499 16.9189 25.516C16.5856 25.382 16.2829 25.182 16.0289 24.9279C15.775 24.6739 15.575 24.3711 15.4412 24.0377C15.3073 23.7044 15.2423 23.3474 15.25 22.9883",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 0 0 -1 26 8)",
    fill: "#09A0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.f2a5072e962794c5dfeffd7ed04cfdb7.svg";
export { ForwardRef as ReactComponent };